import { inject, Injectable } from '@angular/core';
import { SelectTranslations } from '../interfaces/select-translations.interface';
import { SELECT_TRANSLATION_CONFIG } from '../tokens/select-translation-config.token';

export const DEFAULT_SELECT_TRANSLATIONS: SelectTranslations = {
	'select.placeholder': 'Select an option',
	'select.deselect_all': 'Deselect All',
	'select.select_all': 'Select All',
	'general.search': 'Search',
	'general.save': 'Save',
	'general.all': 'All',
	'general.no_data': 'No data available',
};

@Injectable({
	providedIn: 'root',
})
export class SelectTranslationService {
	private config = inject(SELECT_TRANSLATION_CONFIG, { optional: true });

	translate(key: string, params?: any): string {
		if (this.config?.translateFn) {
			return this.config.translateFn(key, params);
		}

		const translations = this.config?.translations || DEFAULT_SELECT_TRANSLATIONS;
		let translation = translations[key] || key;

		// Handle parameter substitution for translations like "max selections: {max}"
		if (params && typeof translation === 'string') {
			Object.keys(params).forEach((param) => {
				translation = translation.replace(`{${param}}`, params[param]);
			});
		}

		return translation;
	}
}
